// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"463":"f48f4bb1","473":"455a38ff","741":"80d8fa3e","774":"5a2c3202","787":"2c0c1695"}[chunkId] + ".chunk.js";
};